import { createContext, useContext } from "react";
import { FALLBACK_TERMS_URL } from "./terms";

/**
 * The Terms document the current page has read, for the footer's Terms link.
 *
 * Provided by the page that read `currentTerms` (Book, across Review and the
 * outcome it replaces Review with). Absent everywhere else, and the footer
 * then links the published page at uselura.com/terms/. One link per page, so
 * the footer can never point somewhere other than the Terms beside the
 * checkbox.
 */
export const TermsDocumentContext = createContext<string | null>(null);

export function useTermsDocumentUrl(): string {
  return useContext(TermsDocumentContext) ?? FALLBACK_TERMS_URL;
}
